/**
 * Oro MX：识别加桌面成功后领取积分。
 * Android：appinstalled；iOS / 已安装：standalone 再进站。
 */

export function isOroMxStandalone(win: Window = window): boolean {
  return (
    win.matchMedia('(display-mode: standalone)').matches ||
    Boolean((win.navigator as Navigator & { standalone?: boolean }).standalone)
  );
}

export type OroMxPwaInstallSignal = 'appinstalled' | 'standalone';

export function shouldClaimOroMxPwaInstall(signal: OroMxPwaInstallSignal, standalone: boolean): boolean {
  return signal === 'appinstalled' || (signal === 'standalone' && standalone);
}

const claimedKeys = new Set<string>();

export function oroMxPwaClaimStorageKey(userId: string): string {
  return `oro_mx_pwa_points:${userId}`;
}

export function hasOroMxPwaClaimedLocally(userId: string, storage: Storage = localStorage): boolean {
  const key = oroMxPwaClaimStorageKey(userId);
  return claimedKeys.has(key) || storage.getItem(key) === '1';
}

export function markOroMxPwaClaimedLocally(userId: string, storage: Storage = localStorage): void {
  const key = oroMxPwaClaimStorageKey(userId);
  claimedKeys.add(key);
  try {
    storage.setItem(key, '1');
  } catch {
    /* ignore quota */
  }
}

export function resetOroMxPwaClaimMemoryForTest(): void {
  claimedKeys.clear();
}
